import React, { useEffect, useState } from "react"
import Modal from './index'
import Input from '../Form/Input'
import FormGroup from "../Form/FormGroup"
import Button from "../Form/Button"
import FormGroupInline from '../Form/FormGroupInline'
import Select from '../Form/Select'
import { MdOutlineAddCard } from "react-icons/md"
import { listMethodsPayment } from "../../utils/utils"
import { getAllCreditCardsByAccount } from "../../schemas/Transaction"

const listTypes = [{ id: "VOIP", value: "Créditos de ligações" }, { id: "CHAT", value: "Créditos de IA" }]
const initialCards = [{ id: "ADD_NEW", value: "Cadastrar novo cartão de crédito" }]

const ModalNewRecharge = ({ onSubmit = () => { }, closeModal = () => { } }) => {
    const [transaction, setTransaction] = useState({})
    const [creditCards, setCreditCards] = useState(initialCards)

    useEffect(() => {
        if (transaction?.method === "CREDIT_CARD") {
            getCreditCards()
        }
    }, [transaction?.method])

    const getCreditCards = async () => {
        if (creditCards?.length > 1) {
            return
        }
        const allCards = await getAllCreditCardsByAccount()
        const formattedCards = allCards?.map(card => ({ id: card?._id, value: card?.name, is_default: card?.is_default })) || []
        setCreditCards([...initialCards, ...formattedCards])
        setTransaction(previousValue => {
            if (previousValue?.method !== "CREDIT_CARD" || previousValue?.card_id) {
                return previousValue
            }
            const defaultCard = formattedCards.find(card => card.is_default) || formattedCards[0]
            return { ...previousValue, card_id: defaultCard?.id || "ADD_NEW" }
        })
    }

    const handleChangeValue = (name, value) => {
        setTransaction(previousValue => { return { ...previousValue, [name]: value } })
    }

    const handleCancel = (e) => {
        e.preventDefault()
        closeModal()
    }

    const handleSave = (e) => {
        e.preventDefault()
        onSubmit(transaction)
    }

    return (
        <Modal
            icon={<MdOutlineAddCard />}
            title={"Nova Recarga"}
            description={"Preencha os campos abaixo e clique em salvar"}
            closeModal={closeModal}
        >
            <form onSubmit={handleSave}>
                <FormGroup labelText="Tipo de Recarga">
                    <Select name="Tipo" placeholder="Pesquise um tipo" options={listTypes || []} selected={transaction?.type ?? ""} onChange={(value) => handleChangeValue("type", value)} multiple={false} />
                </FormGroup>
                {transaction?.type === "CHAT" &&
                    <FormGroup labelText="Conversão">
                        <span>R$ 10,00 = 100 créditos de IA</span>
                    </FormGroup>
                }
                <FormGroup labelText="Valor (Min. R$ 50,00)">
                    <Input type="currency" placeholder="Valor" value={transaction?.value ?? ""} onChange={(e) => handleChangeValue("value", e.target.value)} />
                </FormGroup>
                <FormGroup labelText="Método de Pagamento">
                    <Select name="Método de Pagamento" placeholder="Pesquise um método" options={listMethodsPayment || []} selected={transaction?.method ?? ""} onChange={(value) => handleChangeValue("method", value)} multiple={false} />
                </FormGroup>
                {transaction?.method === "CREDIT_CARD" &&
                    <FormGroup labelText="Cartão de Crédito">
                        <Select name="Selecione uma opção" placeholder="Pesquise um cartão" options={creditCards || []} selected={transaction?.card_id ?? ""} onChange={(value) => handleChangeValue("card_id", value)} multiple={false} />
                    </FormGroup>
                }
                <FormGroupInline>
                    <Button variant='primary' type="submit">Salvar</Button>
                    <Button variant='secondary' onClick={handleCancel}>Cancelar</Button>
                </FormGroupInline>
            </form>
        </Modal>
    )
}

export default ModalNewRecharge
